export default [
    {
        path: '/v3/user/center',
        component: () => import('@/pages/v2/user/user-center'),
    },
    {
        path: '/v3/my-api/batch-add',
        component:() => import('@/pages/v2/user/batch-add')
    },
    {
        path: '/v3/my-api/batch-edit',
        component:() => import('@/pages/v2/user/batch-edit')
    }
    // {
    //     path: '/v3/user/safety',
    //     component: () => import('@/pages/v2/user/user-safety'),
    //     meta: meta
    // },
    // {
    //     path: '/v3/user/preference',
    //     component: () => import('@/pages/v2/user/user-preference'),
    //     meta: meta
    // },
  ];
  


// WEBPACK FOOTER //
// ./src/router/v2/userCenter.js